import { makeQuery } from "api/api";
import * as z from "zod";
import { TimezoneSchema } from "model/timezone/schema";
import { ApiEndpoints } from "api/endpoints";

export const fetchTimezones = async () => {
  const response = await makeQuery(ApiEndpoints.systemTimezones());
  return z.array(TimezoneSchema).parse(response.data);
};
